import React, { useContext, useEffect, useState, memo } from "react";
import { Grid } from "@mui/material";
import PropTypes from "prop-types";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";
import SelectionTypeGroup from "./SelectionTypeGroup";
import { HorizontalSeparator } from "../styled/SidePanel.style";

const TenantSitesDetailsTile = ({
  operatorList = [], // selected op list
  logic = null,
  onchangeOperator,
  isProposedTenants = false,
  siteCounts = [],
  siteCountsNonMno = [],
  mnoOperatorsPermited= [],
  mnoOperatorsOthers = [],
  nonMnoOperatorsPermited = [],
  nonMnoOperatorsOthers = [],
}) => {
  const {
    operatorDetails = [],
  } = useContext(WebMapContext);
  
  const [mnoOperators, setMnoOperators] = useState([]);
  const [nonMnoOperators, setNonMnoOperators] = useState([]);
  useEffect(() => {
    if(mnoOperatorsOthers?.length){
    setMnoOperators([
      ...mnoOperatorsPermited,
      {
        operator: "MNOOthers",
        name: "Others",
      }
    ]);
   } else {
    setMnoOperators(mnoOperatorsPermited);
  }
  if(nonMnoOperatorsOthers?.length){
    setNonMnoOperators([
      ...nonMnoOperatorsPermited,
      {
        operator: "NONMNOOthers",
        name: "Others",
      }
    ]);
  } else {
    setNonMnoOperators(nonMnoOperatorsPermited);
  }
  }, [operatorDetails, mnoOperatorsPermited]);

  const handleOperator = (val, clickFrom) => {
    if (val) {
      let newOp = [];
      const isSelected = operatorList.find(x => x === val);
      if (isSelected) newOp = operatorList.filter(x => x !== val);
      else newOp = [...operatorList, val];
      onchangeOperator({ operatorList: newOp, value: newOp.length <= 1 ? null : !logic ? 'AND' : logic, clickFrom: clickFrom, siteCounts: siteCounts});
    }
  }

  const getCountByOprt = (op, type) => {
    const opCounts = type === 'MNO' ? siteCounts : siteCountsNonMno;
    if (op === 'MNOOthers' || op === 'NONMNOOthers') {
      const opData = opCounts.find(x => x._id === 'Others');
      return opData?.count || 0;
    }
    const opData = opCounts.find(x => x._id === op);
    return opData?.count || 0;
  };

  return (
    <Grid
      container
      xs={12}
      sm={12}
      md={12}
      style={{
        justifyContent: "space-between",
        margin: "5px 5px 0px",
        padding: isProposedTenants ? "none" : "10px",
        font: "normal normal 500 13px/18px Open Sans",
        background: "#FFFFFF 0% 0% no-repeat padding-box",
        border: isProposedTenants ? "none" : "1px solid #007842",
        borderRadius: "5px",
        opacity: "1",
      }}
    >
      {!isProposedTenants ? <h4 style={{ margin: "0px" }}>Existing Tenants</h4> : ''}

      <Grid
        container
        item
        xs={12}
        sm={12}
        md={12}
        style={{
          marginBottom: "5px",
          textAlign: "left",
          font: "normal normal 550 13px/18px Open Sans",
          letterSpacing: "0px",
          color: "green",
          opacity: "1",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ flex: "1", color: "black", padding: "5px" }}>MNO</div>
        <div style={{ float: "right", width: "45%" }}>
          <SelectionTypeGroup
            value={logic}
            handleChange={(val) => onchangeOperator({ operatorList, value: val})}
            disabled={operatorList?.length === 0}
          />
        </div>
      </Grid>
      <Grid container item style={{ justifyContent: "flex-start" }}>
        {mnoOperators.map((x) => (
          <Grid
            item
            md={2.5}
            style={{
              margin: "1px 5px 5px 5px",
              border: `${operatorList.includes(x.operator) ? "2px" : "1px"
                } solid #007842`,
              borderRadius: "4px",
              cursor: "pointer",
              height: "60px",
              width: "60px",
              background: "#FFFFFF 0% 0% no-repeat padding-box",
              boxShadow: "0px 2px 4px #00000026",
            }}
            onClick={() => handleOperator(x.operator, 'MNO')}
          >
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "3px",
              height: "36px",
              width: "100%",
              overflow: "hidden",
            }}>
              {x.icon && !x?.isAnonymized?
                <img
                  src={x.icon}
                  alt={x.name}
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                  class="center"
                  vertical-align="middle"
                /> : <h4 style={{ color: "#036116", fontSize: "10px", textAlign: "center", lineHeight: "8px" }}>{x.name}</h4>}
            </div>
            <div style={{ height: "1px", width: "100%", backgroundColor: "#007842", marginTop: "3px" }} />
            <p style={{ color: "#036116", fontSize: "10px", textAlign: "center", margin: "0px" }}>{getCountByOprt(x.operator, 'MNO')}</p>
          </Grid>
        ))}
      </Grid>
      {nonMnoOperators.length !== 0 && (
        <>
          <HorizontalSeparator />
          <div style={{ width: "100%", padding: "5px" ,color: "black", fontWeight: "550"}}>
            Non-MNO
          </div>
        </>
      )}
      <Grid container item style={{ justifyContent: "flex-start" }}>
        {nonMnoOperators.map((x) => (
          <Grid
            item
            md={2.5}
            style={{
              margin: "1px 5px 5px 5px",
              border: `${operatorList.includes(x.operator) ? "2px" : "1px"
                } solid #007842`,
              borderRadius: "4px",
              cursor: "pointer",
              height: "60px",
              width: "50px",
              background: "#FFFFFF 0% 0% no-repeat padding-box",
              boxShadow: "0px 2px 4px #00000026",
            }}
            onClick={() => handleOperator(x.operator, 'NONMNO')}
          >
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "3px",
              height: "36px",
              width: "100%"
            }}>
              {x.icon && !x?.isAnonymized?
                <img
                  src={x.icon}
                  alt={x.name}
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                  class="center"
                  vertical-align="middle"
                /> : <h4 style={{ color: "#036116", fontSize: "10px", textAlign: "center", lineHeight: "8px" }}>{x.name}</h4>}
            </div>
            <div style={{ height: "1px", width: "100%", backgroundColor: "#007842", marginTop: "3px" }} />
            <p style={{ color: "#036116", fontSize: "10px", textAlign: "center", margin: "0px" }}>{getCountByOprt(x.operator, 'NON-MNO')}</p>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}

export default memo(TenantSitesDetailsTile);

TenantSitesDetailsTile.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
};

TenantSitesDetailsTile.defaultProps = {
  title: undefined,
  icon: undefined,
};
